var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Icon } from '@project/components/base';
import { Button } from '../Forms/Fields';
import VariablePopover from './VariablePopover';
import { VariableCreatorContainer, VariableControlsContainer, VariableListContainer, VariableItemContainer, VariableItem, RemoveVariableButton, } from './styles';
export var VariableCreator = function (_a) {
    var onUpdateVariable = _a.onUpdateVariable, onDeleteVariable = _a.onDeleteVariable, onClearVariables = _a.onClearVariables, buttonTitle = _a.buttonTitle, _b = _a.variables, variables = _b === void 0 ? [] : _b;
    var _c = useState(false), showFilterComponent = _c[0], setShowFilterComponent = _c[1];
    var handleUpdateVariable = function (name, type, defaultValue) {
        setShowFilterComponent(false);
        var typedDefaultValue = defaultValue;
        if (type === 'number') {
            typedDefaultValue = Number(typedDefaultValue);
        }
        else if (type === 'boolean') {
            typedDefaultValue = Boolean(typedDefaultValue);
        }
        onUpdateVariable(name, type, typedDefaultValue);
    };
    return (_jsxs(VariableCreatorContainer, { children: [_jsxs("div", __assign({ className: "w-full" }, { children: [showFilterComponent && (_jsx(VariablePopover, { variableTypes: [
                            { value: 'text', label: 'Text' },
                            { value: 'number', label: 'Number' },
                            { value: 'boolean', label: 'Boolean' },
                            { value: 'timestamp', label: 'Timestamp' },
                        ], onHide: function () { return setShowFilterComponent(false); }, onUpdateVariable: handleUpdateVariable })), !showFilterComponent && (_jsxs(VariableControlsContainer, { children: [_jsxs(Button, __assign({ small: true, subdued: true, onClick: function () { return setShowFilterComponent(true); } }, { children: [buttonTitle, _jsx(Icon, { style: { marginLeft: '10px' }, className: "fa fa-plus" })] })), !!variables.length && (_jsxs(Button, __assign({ small: true, subdued: true, onClick: onClearVariables, style: { marginLeft: '10px' } }, { children: ["clear ".concat(buttonTitle), _jsx(Icon, { style: { marginLeft: '10px' }, className: "fa fa-times" })] })))] }))] })), !!variables.length && (_jsx(VariableListContainer, { children: _jsx(VariableItemContainer, { children: variables.map(function (variable) { return (_jsxs(VariableItem, { children: ["".concat(variable.name, " ; ").concat(variable.type, " ; ").concat(variable.default), _jsx(RemoveVariableButton, __assign({ "data-varname": variable.name, onClick: function (_a) {
                                    var target = _a.target;
                                    return onDeleteVariable(target.parentElement.dataset.varname);
                                } }, { children: _jsx("i", { style: { opacity: '0.7' }, className: "fas fa-times" }) }))] }, variable.name)); }) }) }))] }));
};
export default VariableCreator;
